<template>
  <!-- 达人榜 -->
  <div class="task_box">
    <ul class="task_list_tab flex">
      <li :class="{ on : currentRank == item.type }" v-for="item in tanktab" :key="item.key" @click="changeRankTab(item.type)">{{ item.name }}</li>
    </ul>

    <template v-if="rankListData.length">
      <p class="task_rank_tips flex">
        <span>榜单每日0点刷新</span>
        <span>房间掉落时长</span>
      </p>

      <!-- 我自己 -->
      <div class="task_rank_my">
        <div class="task_rank_my_in flex">
          <p>我自己</p>
          <p>{{ Math.floor(myRankData.user_host_minutes * 100) / 100}}<span>分钟</span></p>
        </div>
        <div class="task_rank_my_avatar" :class="{'task_rank_frame':myRankData.avatar_frame_url}">
          <div class="task_rank_my_avatar_in">
            <img :src="myRankData.avatar" class="task_avatar" v-if="myRankData.avatar">
            <img :src="myRankData.avatar_frame_url" class="task_avatar_frame" v-if="myRankData.avatar_frame_url">
          </div>
        </div>
      </div>

      <!-- 列表 -->
      <ul class="task_rank_list">
        <li class="flex justify" v-for="item in rankListData" :key="item.key" :class="{'task_back': item.rank > 3}">
          <div class="flex alignitem task_in_box_left">
            <div class="task_list_avatar" :class="{'task_rank_frame' : item.avatar_frame_url}">
              <div class="task_list_avatar_in">
                <img :src="item.avatar+'?fop=imageView/2/w/150/h/150'" class="task_avatar" v-if="item.avatar">
                <img :src="item.avatar_frame_url" class="task_avatar_frame" v-if="item.avatar_frame_url">
                <div class="task_list_rank">{{ item.rank }}</div>
              </div>
            </div>

            <div class="task_list_nickname">
              <p class="flex alignitem"><span>{{ item.nickname }}</span>
                <i class="icon icon_small_vip" v-if="item.is_vip"></i>
                <i class="icon" :class="'icon_small_lv'+item.level" v-if="item.level"></i>
              </p>
              <p class="task_game_label" :class="[item.host_and_in_playing_room_id ? 'playing': 'play_normal']" v-if="item.game_name"><span>{{ item.host_and_in_playing_room_id ? '在玩' : '' }} {{item.game_name}}</span></p>
            </div>
          </div>

          <div class="flex justify task_in_box_right">
            <div class="task_list_mins">
              <p>{{ Math.floor(item.red_packet_all_time_minutes * 100) / 100}}</p>
              <p>分钟</p>
            </div>
            <!-- 一起玩class = btn_play 要判断是否在房间内-->
            <!-- 1. 房间外打开时：
  （1）如果用户是房主，且是开房状态，显示一起玩
  （2）其他状态：关注/关注

  2. 房间内打开：无论房主处于什么状态，都是显示关注/未关注 -->
            <button :class="[isInRoom ? 'btn_rank_' + item.user_rel : (!isInRoom && item.host_and_in_playing_room_id ? 'btn_play' : 'btn_rank_' + item.user_rel)]" @click="btnEvent(item)"></button>
          </div>
          
        </li>
      </ul>

      <button class="task_list_more" v-if="!finish" @click="getRank()">查看更多<i class="icon icon_arrow"></i></button>

    </template>

    <template v-else>
      <p class="rank_list_empty">敬请期待</p>
    </template>

  </div>
</template>
<script>
import api from '@/api/index';
export default {
  name: 'redpage',
  data(){
    return {
      rankListData: [],
      myRankData: {},
      tanktab: [
        {
          name: '日榜',
          type: 'daily'
        },
        {
          name: '总榜',
          type: 'total'
        }
      ],
      currentRank: 'daily',
      relative: { // 1 关注, 2 被关注, 3 互相关注, 4 无关注关系
        1: '已关注',
        2: '关注',
        3: '相互关注',
        4: '关注'
      },
      isCanFollow: true,
      page: 1,
      per_page: 10,
      finish: false
    }
  },
  props: {
    isInRoom: Boolean
  },
  mounted(){
    this.getRank('daily')
  },
  methods: {
    follower(item) {
      
      if (item.user_rel == 1 || item.user_rel == 3) return

      if (this.isCanFollow) {
        this.isCanFollow = false
      
        this.$http.post(api.postFollows(),{
          'follow_user_id': item.user_id
        }).then(() => {
          this.$toast({
            css: 'toast-red',
            type: 'success',
            text: '已关注'
          });
          this.$store.dispatch('postBehaviors', {
            action: 'redbag_follow',
            follow_id: item.user_id
          })
          this.updateRelTypes(item);
        }).catch((e) => {
          this.$toast({
            css: 'toast-red',
            type: 'fail',
            text: e && e.data && e.data.errmsgcn || '网络异常'
          });
          this.isCanFollow = true
        });
      }
    },
    updateRelTypes(user) {
      return this.$http.get(api.getUserRelTypes(user.user_id)).then((res) => {
        const rel = res[user.user_id];
        this.$set(user, 'user_rel', rel);
        this.isCanFollow = true
        return user;
      }).catch(() => {});
    },
    changeRankTab(type) {
      if (type === this.currentRank) return
      this.currentRank = type
      this.page = 1
      this.rankListData = []
      this.finish = false
      this.getRank(type)
    },
    getRank(type){
      if (!type) {
        type = this.currentRank
      }
      this.$http.get(api.getRedRank(),{
        params: {
          rank_type: type,
          page: this.page,
          per_page: this.per_page
        }
      }).then((res)=>{
        if (this.page >= (res.total/this.per_page) ) {
          this.finish = true
        }
        this.page += 1
        this.rankListData = this.rankListData.concat(res.items)
        this.myRankData = res.current_user_dict
      })
    },
    btnEvent(item) {
      if (!this.isInRoom && item.host_and_in_playing_room_id) {
        this.$emit('toplay','to')
        return
      }
      this.follower(item)
    }
  }
}
</script>